import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { Platform, useQuery } from "@core/api";
import { OrganizationContext } from "@core/organization";
import Registry from "@core/registry";
import { Debug } from "@core/debug";
import { createContext, useContext, useMemo } from "react";
import { useDispatch } from "react-redux";
import { PrivilegesListActions } from "../privileges/actions/PrivilegesListActions.js";
import { PrivilegesLists, privilegesListsIds } from "../privileges/constants/PrivilegesConstants.js";
import { UserPrivilegesValidator } from "../user/utils/UserPrivilegesValidator.js";
export var PrivilegesContext = /*#__PURE__*/ createContext({
    query: undefined
});
export var usePrivileges = function() {
    var ref, ref1;
    var context = useContext(PrivilegesContext);
    var ref2;
    var userPrivileges = useMemo(function() {
        var ref, ref1;
        return {
            privileges: context === null || context === void 0 ? void 0 : (ref = context.query) === null || ref === void 0 ? void 0 : ref.data,
            access: new UserPrivilegesValidator((ref2 = context === null || context === void 0 ? void 0 : (ref1 = context.query) === null || ref1 === void 0 ? void 0 : ref1.data) !== null && ref2 !== void 0 ? ref2 : [])
        };
    }, [
        (ref = context.query) === null || ref === void 0 ? void 0 : ref.data
    ]);
    if (!context) {
        throw new Error("usePrivileges must be used within a PrivilegesProvider");
    }
    if (!((ref1 = context.query) === null || ref1 === void 0 ? void 0 : ref1.data)) {
        throw new Error("Privileges data is not available");
    }
    return userPrivileges;
};
export var PrivilegesProvider = function(param) {
    var children = param.children;
    var ref, ref1;
    var organizationCtx = useContext(OrganizationContext);
    var organizationId = (ref = organizationCtx.organizationModelQuery) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.id;
    var dispatch = useDispatch();
    var privilegesQuery = useQuery({
        queryKey: [
            "init",
            "user-privileges",
            organizationId
        ],
        queryFn: /*#__PURE__*/ _async_to_generator(function() {
            var privileges;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            Platform.privileges.getUserPrivileges()
                        ];
                    case 1:
                        privileges = _state.sent();
                        dispatch(PrivilegesListActions.addOrOverwrite(privilegesListsIds[PrivilegesLists.User], privileges));
                        Registry.register("userPrivileges", privileges);
                        Debug.setState("privilegesTool", function(prev) {
                            return _object_spread({}, prev, Object.fromEntries(privileges.map(function(privilege) {
                                return [
                                    JSON.stringify(privilege),
                                    true
                                ];
                            })));
                        });
                        return [
                            2,
                            privileges
                        ];
                }
            });
        }),
        retry: false,
        enabled: !!organizationId,
        initialData: Registry.get("userPrivileges", {
            optional: true
        }),
        staleTime: Infinity
    });
    return /*#__PURE__*/ _jsx(PrivilegesContext.Provider, {
        value: {
            query: privilegesQuery
        },
        children: children
    });
};

//# sourceMappingURL=PrivilegesContext.js.map